<template>
    
    <div class="launch-mobile new-margin">
        <div class="container">
            <div class="row align-items-center right-side-flex">
                <div class="col-lg-6 col-md-12">
                    <div class="about-content diff-padding"><span class="sub-title text-uppercase">Smart Solutions</span>
                        <h2>Our Promise</h2>
                        <p>At Meander, we take your software development journey seriously from the initial concept through design, development, testing, and deployment. Our focus is on delivering clean, maintainable code combined with seamless user experiences that engage and delight your customers. We prioritize quality and transparency throughout the process, ensuring your project meets deadlines and exceeds expectations. Whether your solution is mobile-first or cloud-native, we build with future scalability and performance in min. </p>
                      <button
                                data-v-b4360fc6="" class="default-btn ms-2" style="margin-left:0px !important;">Explore
                                Solutions</button>
                
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="about-img"><img src="/img/Mobile-App.b3ddf363.png" alt="launch app"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>

@media screen and (max-width: 767px) {
.new-margin {
    padding-top: 10px !important;
}
.diff-padding {
    padding-top: 30px;
}
}
</style>
<script>
export default {
  name: "LaunchMobile",
};
</script>